import { render, staticRenderFns } from "./ScheduleClass.vue?vue&type=template&id=2ca784ea&scoped=true&"
import script from "./ScheduleClass.vue?vue&type=script&lang=js&"
export * from "./ScheduleClass.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleClass.vue?vue&type=style&index=0&id=2ca784ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca784ea",
  null
  
)

export default component.exports